<app-loader  [isLoading]="isLoading"></app-loader>

<ng-container>
    <div [ngClass]="style" class="share-email-container text-center">
        <h4  class="tagline" [translate]="'share.title'"></h4>
        <hr />
        <div class="content text-left">
          <form [formGroup]="contactForm" (ngSubmit)="sendGrecaptcha()">

              <app-input [isRedesign]="true"
              [parentFormGroup]="contactForm"
              [formControl]="from"
              errorText="{{ 'share.form.errors.from' | translate}}"
              id="share-option-fromInput"
              label="*{{'share.form.labels.from' | translate}}"
              placeholder="{{'share.form.placeholders.from' | translate}}"
              [isRequired]="true"></app-input>


            <app-input [isRedesign]="true"
                [parentFormGroup]="contactForm"
                [formControl]="email"
                id="share-option-emailInput"
                label="*{{'share.form.labels.email' | translate}}"
                errorText="{{ 'share.form.errors.email' | translate}}"
                placeholder="{{'share.form.placeholders.email' | translate}}"
                [isRequired]="true"></app-input>


                <app-input [isRedesign]="true"
                [parentFormGroup]="contactForm"
                errorText="{{ 'share.form.errors.listingUrl' | translate}}"
                id="share-option-listingUrlInput"
                [formControl]="listingUrl"
                label="*{{'share.form.labels.listingUrl' | translate}}"
                [disabled]="true"
                [isRequired]="true"></app-input>

                <app-input [isRedesign]="true"
                [parentFormGroup]="contactForm"
                errorText="{{ 'share.form.errors.subject' | translate}}"
                id="share-option-subjectInput"
                [formControl]="subject"
                label="*{{'share.form.labels.subject' | translate}}"
                placeholder="{{'share.form.placeholders.subject' | translate}}"
                [isRequired]="true"></app-input>


                <div class="comments form-group">
                  <label for="contactAgent-textarea-comments contact-agent__comments-label" translate="share.form.labels.comment"></label>
                  <textarea rows="7" style="width: 100%; color:#5f6062" [formControl]="comments" id="contactAgent-textarea-comments" name="comments" ></textarea>
                </div>

                <app-recaptcha [onSubmit]="getOnSubmit()" (recaptchaIdCreated)="recaptchaId=$event"></app-recaptcha>

                <button id="share-button-send"   class="btn-redesign btn-redesign--center-button btn-redesign--primary btn-redesign--max-size-440 full-width"  [class.commercial]="isCommercial" type="submit"  [class.btn-luxury-inverted]="isLuxury && !contactForm.valid" [class.btn-luxury]="isLuxury && contactForm.valid" [disabled]="!contactForm.valid">
                    <span *ngIf="!isLoading" class="full-width" translate="contact.send-request"></span>
                  </button>
          </form>
        </div>
      </div>
</ng-container>
